import { Options } from "@components/modules/Table/types"
import { confirmation, notify, route } from "@helpers"
import useAuth from "@hooks/useAuth"
import useStatic from "@hooks/useStatic"
import { useMemo } from "react"
import { useHistory } from "react-router"
import MembershipController from "@club/customer/api/MembershipController"

export default function useMembersTableOptions(removeMember: (id: string | number) => Promise<void>) {
    const auth = useAuth()
    const history = useHistory()

    return useStatic<Options<Club.Resources.MembershipPartial>>({
        pageSize: 100,
        actions: [
            { label: "More", action: row => history.push(route("club:owner:member", row.original.id)) }, 
            { label: "Remove", action: row => removeMember(row.original.id), condition: row => auth.user.id !== row.original.user_id }
        ]
    })
}